import { PropsWithChildren } from 'react';

export function HeaderContainer({ children }: PropsWithChildren<{}>) {
  return <div className="flex items-center justify-between gap-2">{children}</div>;
}
